define('app/views/templates/helpers/checkAmount',['Handlebars','underscore'], function ( Handlebars, _ ){
    function checkAmount(amount, otherAmount) {
        var parseAmount = parseFloat(amount);
        var parseOtherAmount = otherAmount ? parseFloat(otherAmount): 0;
        return parseAmount > parseOtherAmount ? true : false;     
    }

    Handlebars.registerHelper( 'checkAmount', checkAmount );
    return checkAmount;
});
